import { Link } from "react-router-dom";
import { siteConfig, navLinks } from "@/content/siteData";
import { MediaChannelLinks } from "@/components/common/MediaChannelLinks";

export const Footer = () => {
  return (
    <footer className="relative z-10 border-t border-border/80 bg-white/70 px-6 py-12 md:px-12 lg:px-24" data-testid="site-footer">
      <div className="mx-auto grid w-full max-w-7xl gap-10 md:grid-cols-[1.3fr_1fr_1fr]">
        <div>
          <h3 className="text-3xl font-semibold text-primary" data-testid="footer-brand-heading">
            {siteConfig.brand}
          </h3>
          <p className="mt-3 max-w-md text-sm text-muted-foreground" data-testid="footer-tagline-text">
            Spoken Hindi coaching for diplomats, embassy families, corporate expats, and global learners.
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-primary/70" data-testid="footer-links-label">
            Quick links
          </p>
          <div className="mt-4 flex flex-col gap-2">
            {navLinks.map((item) => (
              <Link
                key={`footer-${item.path}`}
                to={item.path}
                data-testid={`footer-link-${item.label.toLowerCase()}`}
                className="text-sm text-foreground/80 transition-colors duration-300 hover:text-primary"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-primary/70" data-testid="footer-contact-label">
            Contact
          </p>
          <p className="mt-4 text-sm text-foreground" data-testid="footer-contact-email">
            {siteConfig.email}
          </p>
          <p className="mt-1 text-sm text-foreground" data-testid="footer-contact-city">
            {siteConfig.city}
          </p>
          <p className="mt-1 text-sm text-foreground" data-testid="footer-contact-hours">
            Call: {siteConfig.callHours}
          </p>
          <a
            href={siteConfig.linkedinUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-2 inline-block text-xs text-muted-foreground underline underline-offset-4 transition-colors duration-300 hover:text-primary"
            data-testid="footer-linkedin-link"
          >
            Connect on LinkedIn
          </a>
          <MediaChannelLinks
            testIdPrefix="footer-media-channels"
            heading="Stories & podcasts"
            className="mt-4 bg-muted/35"
          />
          <Link
            to="/courses#free-hindi-resources"
            className="mt-2 block text-xs text-muted-foreground underline underline-offset-4 transition-colors duration-300 hover:text-primary"
            data-testid="footer-free-material-link"
          >
            Free Hindi resources
          </Link>
          <Link
            to="/admin-inquiries"
            className="mt-3 inline-block text-xs text-muted-foreground underline underline-offset-4 transition-colors duration-300 hover:text-primary"
            data-testid="footer-admin-inquiries-link"
          >
            Teacher inquiry login
          </Link>
        </div>
      </div>
    </footer>
  );
};